var xhr = require('xhr');
module.exports = require('./core')(xhr);



//////////////////
// WEBPACK FOOTER
// ./~/ampersand-sync/ampersand-sync-browser.js
// module id = 112
// module chunks = 0